import { http } from '//common/js/http';
export default {
  // 页面访问记录
  loadOperation(data) {
    return http({
      url: '/gepm/api/operation/v1/custom-operation-codes/apply',
        // url: '/gect/api/master-data/v1/data-dicts/all?code=gepm.invoiceType',
      method: 'POST',
      data
    });
  },
  // 获取验证码
  getPhoneCaptcha(data) {
    return http({
      url: '/gepm/api/operation/v1/custom-registers/captcha/send',
      method: 'POST',
      data
    });
  },
  // 刷新图片验证码
  refreshCaptcha(params) {
    return http({
      url: '/gepm/api/operation/v1/custom-registers/captcha/refresh',
      method: 'GET',
      params
    });
  },
  // 提交
  commit(data) {
    return http({
      url: '/gepm/api/operation/v1/custom-registers/register',
      method: 'POST',
      data
    })
  },
  // 获取省份
  getProvince(data) {
    return http({
      url: '/gepm/api/operation/v1/custom-registers/province/list',
      method: 'GET',
      data
    })
  },
}